<div id="about" class="flex-column flex-md-row event__about">
    <div class="image">
      <a target="_blank" [href]="eventPageConfig.orgInfo?.url">
        <img [src]="eventPageConfig.orgInfo.logoUrl" class="d-inline-block align-center" alt="">
      </a>
    </div>
    <div class="d-flex flex-column">
      <div class="title" [innerHTML]="eventPageConfig.orgInfo?.name"></div>
      <div class="desc quill-description" [innerHTML]="eventPageConfig.orgInfo?.desc"></div>
    </div>
</div>